import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

interface JobPayload {
  partner_name: string;
  email_from: string;
  partner_mobile: string | number;
  job_id: number;
  description: string;
}

export const toGetJobs = createAsyncThunk<AxiosResponse<any, any>, any>(
  "jobs/toGetJobs",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}jobs?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toApplyJob = createAsyncThunk(
  "jobs/toApplyJob",
  async (data: JobPayload) => {
    try {
      const response = await axios.post(`${baseUrlApi}jobs`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
